import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { QuickRangeEvent } from '../date-quick-chips/date-quick-chips.component';

enum DateFilterEnum {
  NONE = 'NONE',
  CUSTOM = 'CUSTOM',
}

export interface JobOrderFilters {
  jobCustomer: string;
  jobName: string;
  jobMachine: string;
  date: string;
  fromDate: Date;
  toDate: Date;
}
@Component({
  selector: 'app-job-order-filter-component',
  templateUrl: './job-order-filter.component.html',
  styleUrls: ['./job-order-filter.component.scss'],
})
export class JobOrderFilterComponent implements OnInit {
  @Output()
  apply: EventEmitter<JobOrderFilters> = new EventEmitter();

  activeChip: string | null = null;

  formGroup = new FormGroup({
    jobCustomer: new FormControl(''),
    jobName: new FormControl(''),
    jobMachine: new FormControl(''),
    date: new FormControl(DateFilterEnum.NONE),
    fromDate: new FormControl({ value: '', disabled: true }),
    toDate: new FormControl({ value: '', disabled: true }),
  });

  constructor() {}

  ngOnInit(): void {}

  onQuickRange({ key, from, to }: QuickRangeEvent): void {
    this.activeChip = key;
    this.formGroup.controls.fromDate.reset({ value: from, disabled: false });
    this.formGroup.controls.toDate.reset({ value: to, disabled: false });
    this.formGroup.controls.date.setValue(DateFilterEnum.CUSTOM);
    this.apply.emit({ ...this.formGroup.value, fromDate: from, toDate: to });
  }

  onChange() {
    this.activeChip = null;
    switch (this.formGroup.value.date) {
      case 'CUSTOM': {
        // Enable custom date selection fields
        this.formGroup.controls.fromDate.reset({
          value: this.formGroup.value.fromDate,
          disabled: false,
        });
        this.formGroup.controls.toDate.reset({
          value: this.formGroup.value.toDate,
          disabled: false,
        });
        break;
      }
      default: {
        this.formGroup.controls.fromDate.reset({ value: null, disabled: true });
        this.formGroup.controls.toDate.reset({ value: null, disabled: true });
      }
    }
  }

  onApply() {
    this.apply.emit({
      ...this.formGroup.value,
      fromDate: this.formGroup.value.fromDate,
      toDate: this.formGroup.value.toDate,
    });
  }
}
